import countries from './../../../../common/countries';
import moment from 'moment';

export const initial = {
  period: {
    name: '7days',
    from: moment()
      .startOf('day')
      .add(-7, 'day'),
    to: moment()
      .startOf('day')
      .add(1, 'day'),
  },
  breakdown: 'adUnits',
  metrics: {
    active: 'earnings',
    visible: ['earnings', 'ecpm', 'numberOfImpressions', 'numberOfClicks', 'numberOfLeads'],
  },
  insights: {
    active: 'topGeo',
    visible: ['topGeo', 'topApp', 'impressionsPerUser', 'adEngagement', 'arpau'],
    topGeo: '',
    topApp: '',
    impressionsPerUser: '',
    adEngagement: '',
    arpau: '',
    topGeoChartData: [],
    topAppChartData: [],
    periodChartData: {
      moments: [],
      series: {},
    },
  },
  performance: [],
  chart: {
    moments: [],
    series: {},
  },
  table: {
    rows: '',
    sort: { key: 'numberOfImpressions', order: -1 },
    filter: {
      os: '',
      adType: '',
      appName: '',
      placementName: '',
    },
    currentPage: 1,
    numberOfPages: 0,
    itemsPerPage: 10,
  },
  filterReferences: [],
  apps: [],
  placements: [],
  adUnits: [],
  displayedFilters: {
    apps: [],
    adUnits: [],
    placements: [],
  },
  isFetching: false,
  filter: {
    adUnits: '',
    apps: '',
    countries: countries.map(({ value }) => value),
    placements: '',
  },
  isCorrectPeriod: true,
  shouldSidebarBeShown: true,
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/dashboard.state.js
 **/